export const MC_TAG_DOLLAR_A_MONTH_ID = '6672211';
